import { store$ } from '@redux/store';
import { map, filter, distinctUntilChanged, pairwise } from 'rxjs';
import PageLayout from '../../../layout/constants/pageLayoutNames';

const pageLayoutDivContainer = document.querySelector('[data-page-layout-container]');

/**
 * changes the class of the srp container which determines how the page displays different elements
 * @param {*} layoutName
 */
const changePageLayoutClass = (layoutName) => {
  const [lastValue, newValue] = layoutName;
  if (pageLayoutDivContainer) {
    const lastPageLayoutName = PageLayout.fromKey(lastValue);
    const newPageLayoutName = PageLayout.fromKey(newValue);
    const newLayoutClass = [`nhs-c-wrapper--${newPageLayoutName}`, `nhs-mq-wrapper--${newPageLayoutName}-medium`];
    const layoutClassToRemove = [
      `nhs-c-wrapper--${lastPageLayoutName}`,
      `nhs-mq-wrapper--${lastPageLayoutName}-medium`,
    ];
    pageLayoutDivContainer.classList.remove(...layoutClassToRemove);
    pageLayoutDivContainer.classList.add('srp-content', ...newLayoutClass);
  }
};

// used to select the page layout  from the UI store
const selectPageLayout = (state) => state?.uiState?.pageLayout;

// create an observable that will emit the page layout when they change
const onPageLayoutChange$ = store$.pipe(map(selectPageLayout), filter(Boolean), distinctUntilChanged(), pairwise());

// subscribe to the observable and call the toggleClearAllButton function
onPageLayoutChange$.subscribe(changePageLayoutClass);
